import { keyBy } from 'lodash'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router'

import Tooltip from 'components/Tooltip'
import Image from 'components/Image'

import { getRevenueCenterImage } from 'store/RevenueCenters/selector'
import { getMenusStatus } from 'store/RevenueCenters/selector'
import IconDefaultImage from 'assets/icons/IconDefaultImage.svg'
import { ReactComponent as IconError } from 'assets/icons/IconError.svg'
import {
  getPickupForConcessions,
  getDisplayMenuName,
  getMenuUuidsForEmptyMerchantId,
} from 'utils/revenueCenters'
import { revenueCenterContainsMobileMenus } from 'utils/revenueCenters'
import { createRevenueCenterImageLink } from 'utils/links'
import useFetchImages from 'hooks/useFetchImages'

const Item = ({
  name,
  uuid,
  menus,
  merchantId,
  orgName,
  updatedResourceUuid,
}) => {
  const containsMobileMenus = revenueCenterContainsMobileMenus(menus)

  const history = useHistory()

  const status = useSelector((state) => getMenusStatus(state, uuid))
  const optimisticImage = useSelector((state) =>
    getRevenueCenterImage(state, uuid)
  )

  const { images, loading: isRevenueCenterImageLoading } =
    useFetchImages(createRevenueCenterImageLink([uuid], orgName))

  const image = images?.[uuid] ?? null

  const statusByType = keyBy(status, 'type')

  const onClickItem = () => {
    history.push({ state: { revenueCenterUuid: uuid } })
  }

  const revenueCenterImage =
    updatedResourceUuid === uuid ? optimisticImage : image

  // return menus uuids which should have displayed error icon
  const menuUuidsForEmptyMerchantId =
    getMenuUuidsForEmptyMerchantId(menus)

  return (
    <div className="item">
      <div className="row" onClick={onClickItem} role="button">
        <div className="item-info-wrapper padding-right-xs">
          <span className="name font-weight-bold d-flex align-items-center w-100">
            <span>{name}</span>
            {!merchantId && containsMobileMenus && (
              <Tooltip text="Missing Merchant" relative>
                <span className="d-flex padding-bottom-smalest margin-left-xs margin-right-base">
                  <IconError />
                </span>
              </Tooltip>
            )}
          </span>
        </div>
        <div className="item-info-wrapper">
          <div className="item__image">
            <Image
              src={`${URL.createObjectURL(
                revenueCenterImage ?? new Blob()
              )}`}
              isFallbackImage={image}
              isImage={!!image}
              alt={`item-${name}`}
              isLoading={isRevenueCenterImageLoading}
              fallbackImageSrc={IconDefaultImage}
              fallbackImageAlt={`empty item-${name}`}
            />
          </div>
        </div>
        <div className="item-info-wrapper -menus-status-wrapper">
          <div className="menu-statuses">
            {menus?.map((menu) => {
              const { name, displayName } = getDisplayMenuName(menu)

              return (
                <div className="item-type" key={menu.uuid}>
                  {menuUuidsForEmptyMerchantId?.includes(
                    menu.uuid
                  ) && (
                    <Tooltip text="Missing Merchant">
                      <span className="item-type__error-icon">
                        <IconError />
                      </span>
                    </Tooltip>
                  )}
                  <span
                    className={`item-type__dot  -${
                      statusByType[
                        getPickupForConcessions(
                          menu?.serviceType
                        ).toUpperCase()
                      ]?.availability ?? 'on'
                    }`}
                  ></span>
                  <p>
                    <span className="item-type--bold">{name}</span>:
                    <span className="menu-item-container">
                      <span className="menu-item">{displayName}</span>
                    </span>
                  </p>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Item
